import moment from 'moment';

export default {
  getWeekFromNow() {
    const today = moment();
    const start = today.clone().startOf('isoWeek');
    const end = today.clone().endOf('isoWeek');
    return this.enumerateDaysBetweenDates(start, end);
  },
  getFromNow() {
    const start = moment();
    const end = start.clone().add(6, 'days');
    return this.enumerateDaysBetweenDates(start, end);
  },
  /**
   * Retourne la semaine actuelle
   */
  getCurrentWeek() {
    return this.getWeekFromDay(moment());
  },
  /**
   * Retourne la semaine dernière
   */
  getPreviousWeek(day = moment()) {
    return this.getWeekFromDay(day.clone().subtract(7, 'days'));
  },
  /**
   * Retourne la semaine prochaine
   */
  getNextWeek(day = moment()) {
    return this.getWeekFromDay(day.clone().add(7, 'days'));
  },
  /**
   * Retourne une semaine (lundi - dimanche) à partir d'un jour
   * @param {moment} day
   */
  getWeekFromDay(day) {
    const start = day.clone().startOf('isoWeek');
    const end = day.clone().endOf('isoWeek');
    return this.enumerateDaysBetweenDates(start, end);
  },
  enumerateDaysBetweenDates(startDate, endDate) {
    const dates = [startDate.clone()];

    const currDate = moment(startDate).startOf('day');
    const lastDate = moment(endDate).startOf('day');

    while (currDate.add(1, 'days').diff(lastDate) < 0) {
      dates.push(currDate.clone());
    }
    dates.push(endDate.clone());

    return dates;
  },

  /**
   * Transforme une date (timestamp) en date french
   */
  toFrenchDate(date) {
    return moment(date).format('DD/MM/YYYY');
  },
};
